import React from "react";

// Styles \\
import styles from "./FourZeroFour.module.scss";

const FourZeroFour = () => {
  // JSX \\
  return (
    <main className={`container ${styles.fourZeroFour}`}>
      <div>ERROR 404</div>
      <div>PAGE NOT FOUND</div>
    </main>
  );
};

export default FourZeroFour;
